"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = ["colspan"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = { class: "hidden pt-4" };
const tagStore_1 = require("../../../stores/tag/tagStore");
const discountPopupStore_1 = require("../../../stores/discountPopup/discountPopupStore");
const vue_router_1 = require("vue-router");
const customDesignStore_1 = require("../../../stores/customDesign/customDesignStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'DiscountRow',
    props: {
        product: null
    },
    setup(__props) {
        const tagStore = (0, tagStore_1.useTagStore)();
        const discountPopupStore = (0, discountPopupStore_1.useDiscountPopupStore)();
        const customDesignStore = (0, customDesignStore_1.useCustomDesignStore)();
        const router = (0, vue_router_1.useRouter)();
        const shouldShowDiscount = (discount) => {
            if (tagStore.isExportPartner) {
                // Ha export partner akkor csak a külföldi akciókat mutatjuk
                return discount.foreigner === true;
            }
            // Ha nem export partner akkor csak a belföldi akciókat mutatjuk
            return discount.foreigner === false;
        };
        return (_ctx, _cache) => {
            return (__props.product.discounts && __props.product.discounts.length && !(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                    key: 0,
                    id: `discount-row-${__props.product.id}`
                }, [
                    (0, vue_2.createElementVNode)("td", {
                        colspan: (0, vue_2.unref)(tagStore).activeColumnCount,
                        class: "!p-0"
                    }, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.product.discounts, (discount) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: discount.id
                            }, [
                                (shouldShowDiscount(discount))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                        key: 0,
                                        class: (0, vue_2.normalizeClass)(["discount-theme discount-theme-0 cursor-pointer", discount.class])
                                    }, [
                                        (0, vue_2.createElementVNode)("div", {
                                            class: "font-bold text-sm py-1 px-4",
                                            onClick: ($event) => ((0, vue_2.unref)(discountPopupStore).beginProcess((0, vue_2.unref)(router), discount.id))
                                        }, (0, vue_2.toDisplayString)(discount.teaser), 9, _hoisted_3),
                                        (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)(discount.description), 1)
                                    ], 2))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ]));
                        }), 128))
                    ], 8, _hoisted_2)
                ], 8, _hoisted_1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
